import { SORT_ORDER } from '../constants/filter.constant';
import { DefaultResponse } from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';

const CAD_URL = '/cad/v1';

export interface ParamsGetCadResult {
  study_sop_id: string;
}
export interface ResponseGetCadResult extends DefaultResponse {
  data: ResponseGetCadRule['data'][];
}
export const getCadResult = async (params: ParamsGetCadResult) => {
  const response = (await api({
    url: `${CAD_URL}/result`,
    method: 'GET',
    params,
    timeout: 30000,
  })) as AxiosResponse<ResponseGetCadResult>;

  return response.data;
};

export interface ParamsGetCadRules {
  active?: boolean;
  body_part?: string;
  created_at_from?: string;
  created_at_to?: string;
  creator_ids?: string[];
  institution_ids?: string[];
  limit?: number;
  modalities?: string[];
  name?: string;
  offset?: number;
  sort_field?: '' | 'active' | 'name' | 'institution_id' | 'updated_at';
  sort_order?: SORT_ORDER;
  updated_at_from?: string;
  updated_at_to?: string;
}
export interface ResponseGetCadRules extends DefaultResponse {
  data: {
    active: boolean;
    api_key: string;
    auto_send: boolean;
    body_parts: string[];
    created_at: string;
    creator_id: string;
    delay: number;
    id: string;
    institution_id: string;
    modalities: string[];
    name: string;
    updated_at: string;
  }[];
}
export const getCadRules = async (params: ParamsGetCadRules) => {
  const response = (await api({
    url: `${CAD_URL}/rules`,
    method: 'GET',
    params,
  })) as AxiosResponse<ResponseGetCadRules>;

  return response.data;
};
export interface ResponseGetCadRule extends DefaultResponse {
  data: {
    created_at: string;
    id: string;
    model: string;
    result: string;
    status: number;
    study_sop_id: string;
    updated_at: string;
  };
}
export const trackCadResult = async (id: string) => {
  const response = (await api({
    url: `${CAD_URL}/track/${id}`,
    method: 'GET',
  })) as AxiosResponse<ResponseGetCadRule>;

  return response.data;
};

export interface ParamsCreateCadRule {
  active: boolean;
  api_key: string;
  auto_send: boolean;
  body_parts: string[];
  delay: number;
  institution_id: string;
  modalities: string[];
  name: string;
}
export const createCadRule = async (data: ParamsCreateCadRule) => {
  const response = (await api({
    url: `${CAD_URL}/rules`,
    method: 'POST',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsSubmitCadDiagnose {
  model: 'chestxray';
  uid?: string;
}
export const submitCadDiagnose = async (data: ParamsSubmitCadDiagnose) => {
  const response = (await api({
    url: `${CAD_URL}/diagnose`,
    method: 'POST',
    data: {
      ...data,
      model: 'chestxray',
    },
  })) as AxiosResponse<any>;

  return response.data;
};

export type ParamsUpdateCadRule = Omit<ParamsCreateCadRule, 'institution_id'>;
export const updateCadRule = async (id: string, data: ParamsUpdateCadRule) => {
  const response = (await api({
    url: `${CAD_URL}/rules/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export const deleteCadRule = async (id: string) => {
  const response = (await api({
    url: `${CAD_URL}/rules/${id}`,
    method: 'DELETE',
  })) as AxiosResponse<any>;

  return response.data;
};
